// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NXUr","toggle":"styles_toggle__2gWY-","preview":"styles_preview__2IMzq"};